// generated from 177 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const deviceCountFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("device_count_filter"),
  comparison_key: z.enum([
    "3", // 112 (63.28%)
    "1", // 59 (33.33%)
    "5", // 6 (3.39%)
  ]),
  display_name: z.string(),
  // undefined: 60 (33.90%), defined 117 (66.10%)
  raw_value: z.int().min(0).optional(),
  value: z.int().min(0),
  varies_by_app_group: z.literal(false),
});
